@if (orderItem()) {
    @for (extraGroup of individualExtraGroups(); track extraGroup) {
        <div class="extra-group" woa-responsive #group
             [ngClass]="{
                 'single-select': menuModel.extraGroupIsSingleSelect(extraGroup),
                 'multi-select': !menuModel.extraGroupIsSingleSelect(extraGroup),
                 'compact': multiSelectExtraGroupIsCompacted().get(extraGroup.id),
                 'only-group': availableExtraGroupCount() === 1,
                 'within-composite-item': compositeItem()
            }">
            <div class="extra-group-header" woa-activatable (onActivate)="toggleExtra(extraGroup, body, group)">
                <div class="extra-group-header-title">
                    <div class="extra-group-header-title-extra">
                        {{ extraTitle()(extraGroup) | translate: extraTitleParams()(extraGroup) }}
                    </div>
                    @if (extraTitle()(extraGroup, 'quantity') | translate: extraTitleParams()(extraGroup) | trim; as qtyTitle) {
                        <div class="extra-group-header-title-quantity"
                             [ngClass]="{'error': orderModel.addToOrderAttempted() && orderItem().isExtraGroupBelowQuantityMinimum()(extraGroup)}">
                            {{ qtyTitle }}
                        </div>
                    }
                </div>
                @if (!promotedExtraGroup()) {
                    <div class="extra-group-header-selection">
                        @if (menuModel.showExtrasSelected(extraGroup)) {
                            <div class="extra-group-header-selection-selected">
                                {{ 'woa.label.extras.countSelected' | translate: extraTitleParams()(extraGroup) }}
                            </div>
                        }
                        <woa-toggle class="extra-group-header-selection-toggle"
                                    [active]="extraExpanded().has(extraGroup.id) && extraExpanded().get(extraGroup.id)"></woa-toggle>
                    </div>
                }
            </div>
            <div class="extra-group-body" [ngClass]="{'expanded': extraExpanded().has(extraGroup.id) && extraExpanded().get(extraGroup.id)}" #body>
                @for (extraProduct of availableExtraProducts().get(extraGroup.id); track extraProduct.productLine.sellableId; let i = $index) {
                    @if (menuModel.extraGroupIsSingleSelect(extraGroup)) {
                        <woa-order-item-option-control class="extra-group-body-option" id="single-select-option-{{i}}"
                                                       #option
                                                       [image]="menuModel.getExtraProductImage(extraProduct)"
                                                       [imageOverlay]="extraProduct.menuItem?.productImageOverlay"
                                                       [layout]="responsiveService.mobile() ? OrderItemOptionLayout.HORIZONTAL : OrderItemOptionLayout.VERTICAL"
                                                       [aligned]="alignAllSingleSelectExtrasForImages() || showImage()(extraGroup)"
                                                       [title]="menuModel.getExtraProductDisplayName(extraProduct)"
                                                       [price]="menuModel.extraPrice()(extraProduct, extraGroup, orderItem().basePriceForGroup()(extraGroup.id))"
                                                       [showImage]="showImage()(extraGroup, extraProduct)"
                                                       [unavailable]="showSingleSelectExtraUnavailable()(extraGroup, extraProduct)"
                                                       [selected]="orderItem().orderedExtraForExtraSellableId()(extraGroup.id, extraProduct.productLine.sellableId) != undefined"
                                                       (onSelect)="selectSingleSelectExtra(extraGroup, extraProduct, i, option, body)">
                            @if (swapLink()(extraGroup, extraProduct); as swapLink) {
                                <woa-link class="extra-group-body-option-action"
                                          [link]="'woa.button.order.swapExtra'"
                                          [translationParams]="{'name': swapLink}"
                                          (onActivate)="swapExtra(extraGroup, extraProduct, i)"></woa-link>
                            }
                        </woa-order-item-option-control>
                    } @else {
                        <woa-order-item-option-control class="extra-group-body-option" id="multi-select-option-{{i}}"
                                                       [image]="menuModel.getExtraProductImage(extraProduct)"
                                                       [imageOverlay]="extraProduct.menuItem?.productImageOverlay"
                                                       [controlType]="SelectorType.CHECKBOX"
                                                       [layout]="responsiveService.mobile() ? OrderItemOptionLayout.HORIZONTAL : OrderItemOptionLayout.VERTICAL"
                                                       [compact]="multiSelectExtraGroupIsCompacted().get(extraGroup.id)"
                                                       [aligned]="multiSelectExtraGroupIsAlignedForImages().get(extraGroup.id)"
                                                       [title]="menuModel.getExtraProductDisplayName(extraProduct)"
                                                       [price]="extraProduct.price"
                                                       [hidePrice]="menuModel.extraGroupHasNoChoiceWithDefaultAtLimit()(extraGroup, extraProduct)"
                                                       [showEmptyPrice]="anyOptionHasPrice()(extraGroup.id)"
                                                       [showImage]="showImage()(extraGroup, extraProduct)"
                                                       [showControl]="showMultiSelectCheckbox()(extraGroup, extraProduct)"
                                                       [disableControl]="disableMultiSelectCheckbox()(extraGroup, extraProduct)"
                                                       [unavailable]="showMultiSelectExtraUnavailable()(extraGroup, extraProduct)"
                                                       [selected]="getExtraQuantity()(extraGroup, extraProduct) > 0"
                                                       (onSelect)="selectMultiSelectExtra(extraGroup, extraProduct, body)">
                            @if (showExtraQuantity()(extraGroup, extraProduct, showMultiSelectCheckbox()(extraGroup, extraProduct))) {
                                <div class="extra-group-body-option-quantity" slot="details">
                                    <woa-quantity-control [decrementDisabled]="!canDecrementExtra()(extraGroup)"
                                                          (onDecrement)="decrementExtra(extraGroup, extraProduct, body)"
                                                          [incrementUnavailable]="!canIncrementExtra()(extraGroup, extraProduct)"
                                                          (onIncrement)="incrementExtra(extraGroup, extraProduct, body)"
                                                          [quantity]="getExtraQuantity()(extraGroup, extraProduct)"></woa-quantity-control>
                                </div>
                            }
                        </woa-order-item-option-control>
                    }
                }
            </div>
        </div>
    }
    @if (combinedExtraGroups().length) {
        <div class="extra-group combined" woa-responsive woa-activatable (onActivate)="chooseCombinedExtras($event)"
             [ngClass]="{
                 'only-group': availableExtraGroupCount() === 1,
                 'within-composite-item': compositeItem()
             }">
            <div class="extra-group-header">
                <div class="extra-group-header-title">
                    <div class="extra-group-header-title-extra">
                        {{ 'woa.heading.order.extras.title' | translate }}
                    </div>
                </div>
                <div class="extra-group-header-selection">
                    <woa-toggle class="extra-group-header-selection-toggle" [active]="false"></woa-toggle>
                </div>
            </div>
            @let extras = orderItem().optionalOrderedExtrasForGroups()(combinedExtraGroups());
            @if (extras.length) {
                <div class="extra-group-body expanded">
                    <div class="extra-group-body-list">
                        @for (orderExtraItem of extras; track orderExtraItem) {
                            <!--suppress JSUnresolvedReference -->
                            @if (orderExtraItem.nameSignal()) {
                                <div class="extra-group-body-list-item"
                                     [ngClass]="{'nested': orderExtraItem.isNestedSignal()}">
                                    <!--suppress JSUnresolvedReference -->
                                    @if (orderExtraItem.quantitySignal() > 1) {
                                        <div class="extra-group-body-list-item-qty">
                                            {{ orderExtraItem.quantitySignal() }}
                                        </div>
                                    }
                                    {{ orderExtraItem.nameSignal() }}
                                </div>
                            }
                        }
                    </div>
                </div>
            }
        </div>
    }
}
